window.workloadCalculatorApp = angular.module("cerego.workloadCalculator", [
  "cerego.common"
])

require('./workload-calculator/directives/workload-review-visual.js')
require('./workload-calculator/workload-calculator-controller.js')

